<template>
    <div>
        <v-container fill-height fluid>
            <v-row>
                <v-col cols="6" class="pa-0">
                    <AuthSidebar/>
                </v-col>
                <v-col cols="6" class="pa-0">
                <div class="right-section ">
                    <div class="flex-direction-box">
                            <div class="login-from vertical-center">
                                <h2 style="margin-left: 14px">Pre-Registration</h2>
                                <p style="margin-left: 14px" class="gray--text">Please fill out the following details to get started.</p>
                                <form>
                                <v-card>
                                    <v-card-text>
                                        <v-row>
                                            <v-col sm="8" md="6">
                                                <div class="subtitle">{{$t('First Name')}}<span class="red--text">*</span></div>
                                                <v-text-field
                                                    outlined
                                                    dense
                                                    v-model="firstName"
                                                    :rules="rules.firstName"
                                                    placeholder="Enter your first name"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col sm="8" md="6">
                                                <div class="subtitle">{{$t('Last Name')}}<span class="red--text">*</span></div>
                                                <v-text-field
                                                    outlined
                                                    dense
                                                    v-model="lastName"
                                                    :rules="rules.lastName"
                                                    placeholder="Enter your last name"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row class="mt-0">
                                            <v-col sm="12" md="6">
                                                <div class="subtitle">{{$t('Email')}}<span class="red--text">*</span></div>
                                                <v-text-field
                                                    outlined
                                                    dense
                                                    v-model="email"
                                                    :rules="rules.email"
                                                    placeholder="Enter your email"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col sm="8" md="6">
                                                <div class="subtitle">{{$t('Country')}}<span class="red--text">*</span></div>
                                                <v-autocomplete
                                                    outlined
                                                    :items="countries"
                                                    item-value="Code"
                                                    class="rounded-r-0 outline-l-0 crs-p text-no-wrap"
                                                    :filter="filterCountry"
                                                    dense
                                                    v-model="countryId"
                                                    :rules="rules.countryId"
                                                    placeholder="Select Country"
                                                >
                                                    <template v-slot:item="slotProps">
                                                        <i :class="['mr-2', 'em', `em-flag-${slotProps.item.Code.toLowerCase()}`]"></i>
                                                        {{`${slotProps.item.Name}`}}
                                                    </template>
                                                    <template class="d-flex" slot="selection" slot-scope="data">
                                                        <i :class="['mr-2', 'em', `em-flag-${data.item.Code.toLowerCase()}`]"></i>
                                                        <span  class="text-no-wrap">{{`${data.item.Name}`}}</span>
                                                    </template>
                                                </v-autocomplete>
                                            </v-col>
                                        </v-row>
                                        <v-row class="mt-0">
                                            <!-- <v-col sm="12" md="6">
                                                <div class="subtitle">Phone Number<span class="red--text">*</span></div>
                                                <v-autocomplete
                                                    outlined
                                                    dense
                                                    v-model="countryCode"
                                                    :items="countries"
                                                    item-value="MobileCode"
                                                    :filter="filterCountry"
                                                    :rules="rules.countryCode"
                                                    
                                                >
                                                    <template v-slot:item="slotProps" >
                                                        <i :class="['mr-2', 'em', `em-flag-${slotProps.item.Code.toLowerCase()}`]"></i>
                                                        {{`${slotProps.item.Name} (+${slotProps.item.MobileCode})` }}
                                                    </template>
                                                    <template slot="selection" slot-scope="data">
                                                        <i :class="['mr-2', 'em', `em-flag-${data.item.Code.toLowerCase()}`]"></i>
                                                        {{`${data.item.Name} (+${data.item.MobileCode})` }}
                                                    </template>
                                                </v-autocomplete>
                                                <v-text-field
                                                    outlined
                                                    dense
                                                    :items="countries"
                                                    :filter="filterCountry"
                                                    class="rounded-r-0 outline-l-0 crs-p text-no-wrap"
                                                    item-value="MobileCode"
                                                    v-model="mobile"
                                                    :rules="rules.mobile"
                                                    placeholder="Enter your phone number"
                                                ></v-text-field>
                                            </v-col> -->
                                            <v-col sm="12" md="6">
                                                <div class="subtitle">Mobile Number</div>
                                                <v-row no-gutters class="d-flex">
                                                    <v-col cols="5">
                                                        <v-select
                                                            style="background: #E8E8E8; min-width: min-content;"
                                                            outlined
                                                            :items="countries"
                                                            class="rounded-r-0 outline-l-0 crs-p text-no-wrap"
                                                            item-value="MobileCode"
                                                            v-model="countryCode"
                                                            :filter="filterCountry"
                                                            dense
                                                        >
                                                            <template  v-slot:item="slotProps">
                                                                <i :class="[ 'em', `em-flag-${slotProps.item.Code.toLowerCase()}`]"></i>
                                                                {{`${slotProps.item.Name}` }}
                                                            </template>
                                                            <div class="truncate" slot="selection" slot-scope="data">
                                                                <span >
                                                                <i :class="['em', `em-flag-${data.item.Code.toLowerCase()}`]"></i>
                                                                {{`+${data.item.MobileCode }` }}</span>
                                                            </div>
                                                        </v-select>
                                                    </v-col>
                                                    <v-col cols="7">
                                                        <v-text-field
                                                            placeholder="Enter your phone number"
                                                            class="rounded-l-0"
                                                            outlined
                                                            dense
                                                            v-model="mobile"
                                                        ></v-text-field>
                                                    </v-col>
                                                </v-row>
                                                
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                        <v-col cols="6">
                                        <v-checkbox
                                            v-model="permissionToContact"
                                            label="Permission To Contact"
                                        ></v-checkbox>
                                        </v-col>
                                        </v-row>
                                    </v-card-text>
                                    <v-card-actions >
                                        <v-row >
                                            <v-col align="center">
                                            <!-- @click="dialog = true" -->
                                                <v-btn
                                                    @click="preRegister"
                                                    block
                                                    color="primary"
                                                    style="margin-left: 8px"
                                                >
                                                REGISTER NOW
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-card-actions>
                                </v-card>
                                </form>
                            </div>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-container>
        <v-dialog
                v-model="dialog"
                max-width="700"
                persistent
            >
                <v-card rounded="0">
                    <v-toolbar
                        elevation="0"
                        class="white--text"
                        flat
                        dense
                    >
                        <v-spacer></v-spacer>
                        <v-btn
                            color="black"
                            class="white--text"
                            icon
                            @click="dialog = false"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                </v-card>    
                <v-card rounded="0" style="padding-top: 60px;" max-width="700">
                    
                    <v-card-text class="d-flex justify-center">
                        <v-card flat max-width="300"> 
                            <v-img style="margin:auto;" src="/icons/userinfo.png" width="70"></v-img>
                            <v-card-title class="justify-center">
                                <div>
                                    <h2>Congratulations</h2>
                                </div>
                            </v-card-title>
                            <v-card-text class="text-center">
                                <p style="color: black;">We have received your request.</p>
                            </v-card-text>
                        <v-card-actions style="margin-bottom: 80px">
                            <v-btn
                                color="primary"
                                @click="openDialog()"
                                block
                                max-width="30"
                            >
                                DONE
                            </v-btn>
                        </v-card-actions>
                        </v-card>
                    </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";
import generalMixin from "@/mixins/GeneralMixin";
import countries from "@/constants/countries.js"
import AuthSidebar from "./AuthSidebar.vue"
import UserService from "@/_services/UserService"
// import MobileRegister from "./MobileRegister.vue";

  export default {
	mounted() {
		if(this.$route.params.type && (this.$route.params.type || this.$route.params.type == 'mobile')){
			this.registerType = this.$route.params.type;
		}
	},
	watch: {
		'$route.params.type': {
			handler: function(type) {
				this.registerType = type;
			},
			deep: true,
			immediate: true
		}
	},
	components: {
		AuthSidebar,
		// MobileRegister
	},
	computed: {
		isAuthErr() {
			return this.authErr.length > 0;
		}
	},
    data() {
      return {
		error: false,
		registerType: null,
        countries,
        checkbox: false,
        dialog: false,
        firstName: "",
        lastName: "",
        email: "",
        countryCode: null,
        mobile: "",
        countryId: "",
        permissionToContact: 0,
            rules: {
                firstName: [
                    v => !!v || 'First Name is required',
                    v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                lastName: [
                    v => !!v || 'Last Name is required',
                    v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                email: [
                    v => !!v || 'E-mail is required',
                    v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
                ],
                countryId: [
                    v => !!v || 'Country is required',
                ],
            },
      }
    },
    methods: {
        openDialog() {
            this.dialog = false;
        },

        preRegister(){
            const data = {
                firstName: this.firstName,
                lastName: this.lastName,
                email: this.email,
                mobile: this.mobile,
                countryCode: this.countryCode,
                countryId: this.countryId,
                permissionToContact: this.permissionToContact
            }
            if(data.countryCode === null){
                var index = countries.findIndex(e => e.Code === data.countryId);
                if (index !== -1) {
                    data.countryCode = countries[index].MobileCode;
                }
            }
            
            this.startLoading();
            UserService.preRegister(data)
            .then(res => {
                if(res.code == 200 && res.success == true){
                    this.dialog = true;
                    // const hasErrors = data.message && data.message.errors;
                    this.$notify({
                        title: res.message,
                        type: 'success'
                    });
                }else{
                    this.$notify({
                        title: res.message.errors[0].msg,
                        type: 'error',
                    });
                }
                this.stopLoading();
            })
            .catch(err => {
                console.log('rrr', err);
                this.stopLoading();
            })
        }
    },
    mixins: [loadingMixin, generalMixin]
  };
</script>

<style scoped lang="scss">
.right-section {
	padding: 6px 20px;
	background-color: white;
	height: 100vh;
}
.vertical-center {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  width: 45%
}

.right-section .login-from h2{
	font-size:30px;
	font-family: pop_semiBold;
	font-weight: 600;
	margin-bottom: 0px
}
.right-section .login-from p{
	color:#AABDCF;
	font-size: 12px;
	font-family: pop_regular;
	width: 508px;
	margin-top: 3px;
}
.flex-direction-box {
	height: 546px;
	max-height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
}

select:focus-visible {
	outline: none;
}
.right-section {
	padding: 6px 20px;
	background-color: white;
	height: 100vh;
}
.vertical-center {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.right-section .login-details {
	text-align: end;
}
.right-section .login-details h2 {
	font-size: 14px;
	font-family: pop_regular;
	font-weight: 100;
}
.right-section .login-details h2 a {
	color: #AABDCF;
	font-family: pop_semiBold;
	text-decoration: none;
	margin-left: 4px;
}
.right-section .login-from h2{
	font-size:30px;
	font-family: pop_semiBold;
	font-weight: 600;
	margin-bottom: 0px
}
.right-section .login-from p{
	color:#AABDCF;
	font-size: 12px;
	font-family: pop_regular;
	width: 308px;
	margin-top: 3px;
}
.flex-direction-box {
	height: 546px;
	max-height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
}
.login-from-fill label {
	display: inline-block;
	margin-bottom: .5rem;
	color: #97A8B8;
	font-size: 14px;
	font-family: Poppins-Medium;
	letter-spacing: 0.5px;  
}
.login-from-fill .form-control {
	display: block;
	width: 100%;
	height: calc(1.5em + .75rem + 2px);
	padding: .375rem .75rem;
	font-size: 1rem;
	font-weight: 400;
	line-height: 1.5;
	color: #495057;
	transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
	background: #E7F0F8;
	border: 1px solid #C7D5E1;
	border-radius: 3px;
}
.login-from-fill {
	margin-top: 31px;
}

.login-from-fill .forget{
	font-size: 14px;
	font-family: Poppins-Medium;
	text-decoration: none;
	display: block;
	margin-top: 9px;
}


/*forgot css*/
.login-from-fill .form-group.phone-number {
	display: flex;
}
.login-from-fill .number-list {
	width: 52px;
	padding: 6px 4px;
	border-radius: 3px 0px 0px 3px;
	background: #AABDCF;
	color: #fff;
	font-size: 13px;
	height: 38px;
	border: 0px;
}
.login-from-fill .form-control.phone-control {
	margin: 0px;
	border-radius: 0px 3px 3px 0px;
}
select:focus-visible {
	outline: none;
}
input.form-control:focus-visible {
	outline: none;
}
.form-control::placeholder{
	font-size: 13px;
	font-family: pop_regular;
}
.login-from .emailgroup .form-control::placeholder{
	font-size: 13px;
	font-family: pop_semiBold;
}
.v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none;
}

::v-deep .truncate{
  white-space: nowrap; 
  overflow: hidden;
  text-overflow: ellipsis;
  background: #E8E8E8;
  padding-top: -10px;
}
::v-deep .v-input--dense > .v-input__control > .v-input__slot {
    margin-bottom: 0px;
}
::v-deep .v-text-field.v-text-field--enclosed .v-text-field__details {
    padding-top: 0px;
    margin-bottom: 0px;
    background: #FFFFFF;
}
::v-deep .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot, .v-text-field.v-text-field--enclosed .v-text-field__details {
    padding-top: 0px;
    padding-right: 2px;
    padding-bottom: 0px;
    padding-left: 4px;
}

</style>
